import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button, Textarea } from "@windmill/react-ui";

const ConfirmVendorModal = ({
  isOpen,
  onClose,
  onConfirm,
  status,
  statusOptions = [],
  showRemark = true,
}) => {
  const [remarks, setRemarks] = useState("");
  const [goStatus, setGoStatus] = useState("");
  const [initialStatus, setInitialStatus] = useState();

 useEffect(() => {
  setInitialStatus(status);

  if (isOpen) {
    if (statusOptions.length === 1) {
      setGoStatus(statusOptions[0].value);
    } else {
      setGoStatus(undefined);
    }
  } else {
    setRemarks("");
    setGoStatus(undefined);
  }
}, [isOpen, status, statusOptions]);


  const handleRemarkChange = (e) => setRemarks(e.target.value);
  const handleStatusChange = (e) => setGoStatus(e.target.value);

  const handleConfirm = () => {
    onConfirm(remarks, goStatus);
    onClose();
    setRemarks("");
    setGoStatus("");
  };

  const handleClose = () => {
    setRemarks("");
    setGoStatus("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalBody>
        <p className="text-lg font-semibold mb-2">Status Update</p>

        <div className="my-4 flex space-x-4 flex-wrap">
          {statusOptions.map((opt) => (
            <label key={opt.value} className="flex items-center space-x-2 mr-4">
              <input
                type="radio"
                name="status"
                value={opt.value}
                checked={goStatus === opt.value}
                onChange={handleStatusChange}
              />
              <span>
                {status === "2" && opt.value === "1" ? "Unblock" : opt.label}
              </span>
            </label>
          ))}
        </div>

        <div>
          {showRemark && (
            <>
              <p className="text-lg font-medium mb-2">Enter Remark</p>
              <Textarea
                name="vendor_remark"
                value={remarks}
                placeholder="Minimum 10 characters"
                style={{
                  minHeight: "100px",
                  maxHeight: "300px",
                  scrollbarWidth: "thin",
                }}
                onChange={handleRemarkChange}
              />
            </>
          )}
        </div>

        <div className="flex justify-end mt-4 space-x-2">
          <Button layout="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={(showRemark && remarks.trim().length < 10) || !goStatus}
          >
            Confirm
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmVendorModal;
